'use strict';

import dot from "dot";
import Cookies from "js-cookie";

export default class SmartSearchbar {
  constructor($selector, selfInit = true, config) {
    this.$selector = $selector;
    this.breakpoints = config.breakpoints;
    this.$suggestionsTemplate = $("#smartSearchSuggestionsTemplate").html();

    this.action = this.$selector.data('action');
    this.endpoint = this.$selector.data('endpoint');

    this.suggestionsLimitDesktop = this.$selector.data("suggestions-limit-desktop") || 7;
    this.suggestionsLimitMobile = this.$selector.data("suggestions-limit-mobile") || 5;

    if(selfInit) this.init($selector);
  }

  init() {
    this.$search = $('.search-filters__input', this.$selector);

    const suggestionsCallback = (res) => {
      let desktop =  this.suggestionsLimitDesktop
      let mobile =  this.suggestionsLimitMobile
      let itemsClone = res.items
      if($(window).width() >= this.breakpoints.tablet){
        itemsClone = res.items.slice(0,desktop)
      }else{
        itemsClone = res.items.slice(0,mobile)
      }
      let resFiltered = {
        ...res,
        items:itemsClone
      }
      this.renderSuggestions(resFiltered);
    };

    let keyupTimeout;

    this.$search.on('focus', e => {
      if(this.$search.val().length > 3 && $('.search-filters__suggestions ul', this.$selector).length) {
        this.$selector.addClass("active");
      }
    });

    this.$search.on('keyup', e => {
      e.preventDefault();
      clearTimeout(keyupTimeout);


      if (this.$search.val().length > 0) {
        this.$search.parent().find(".error-msg").remove();
        $(".search-filters__searchbar", this.$selector).removeClass(
          "has-error"
        );

        if (this.$search.val().length > 3) {
          // fetch suggestions
          keyupTimeout = setTimeout(() => {
            this.updateData({
              endpoint: this.endpoint,
              data: {
                keyword: this.$search.val()
              },
              callback: suggestionsCallback,
            });
          }, 300);
        } else {
          this.$selector.removeClass("active");
        }
      } else {
        this.$selector.removeClass("active");
      }
    });

    $(document).on("click", (e) => {
      const $eTarget = $(e.target);

      if (
        !$eTarget.hasClass(".smart-searchbar") &&
        !$eTarget.parents(".smart-searchbar").length
      ) {
        this.$selector.removeClass("active");
      } 
    });
  }

  handleSearchSubmit() {
    this.$selector.removeClass("active");

    const eventName = (Cookies.get('imda_profile') === 'profile0') ? 'searchTerm_profile0' : (Cookies.get('imda_profile') === 'profile1') ? 'searchTerm_profile1' : (Cookies.get('imda_profile') === 'profile2') ? 'searchTerm_profile2' : 'searchTerm_profile3'

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'SearchProfile-Film',
      imda_profile: eventName,
      search_term: $('.site-search__input', this.$selector).val()
    });

    window.location.href = `${this.action}?${$('.search-filters__input', this.$selector).attr('name')}=${encodeURIComponent($('.search-filters__input', this.$selector).val())}`;
  }

  renderSuggestions(data) {
    const dotTemplate = dot.template(this.$suggestionsTemplate)(data);

    $(".search-filters__suggestions", this.$selector).html(dotTemplate);

    if(data.items.length) {
      $('.search-filters__suggestions .btn', this.$selector).attr('href', `${this.action}?${this.$search.attr('name')}=${encodeURIComponent(this.$search.val())}`);
    }

    this.$selector.addClass("active");
  }

  updateData({ endpoint, data, callback }) {
    $.ajax({
      url: endpoint,
      // data: data,
      data: JSON.stringify(data),
      method: "post",
      contentType: "application/json",
      success: (res) => {
        callback(res);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
